
$models = {

	all : {

		current_token : '',
		current_username : '',

		getDataFromAPI : function($requestName, $params, $callbackSuccess, $callbackFailure, $type, $actionType, $superCache, $contentType, $cache) {

			if (($type == 'POST') || ($type == 'PUT')) {
				$cached.JSONdata.dataHasChanged();
				jQuery('input[type="button"], input[type="submit"]').attr('disabled', 'disabled');
			}

			console.log('API request: '+$requestName);

			$models.all.apiRequestUrl = $config.api_protocol + $config.api_hostname + $config.api_path + '/' + $requestName;
			$models.all.superCacheKey = $models.all.apiRequestUrl + '?' + jQuery.param($params);

			if (!$type) {
				$type = 'GET';
			}
			if (!$actionType) {
				$actionType = 'generic';
			}
			if (!$superCache) {
				$superCache = false;
			}
			if ($cache !== false) {
				$cache = true;
			}

			// BUGFIX FOR IE - #531
	/*		if (($type == 'PUT') || ($type == 'DELETE')) {
				if (!$params) { $params = {}; }
				$params['_method'] = $type;
				$type = 'POST';
			}
	*/
			$models.all.options = {
				superCacheKey:$models.all.superCacheKey,
				url:$models.all.apiRequestUrl,
				type:$type,
				cache:$cache,
				success:function($data) {
					jQuery('input[type="button"], input[type="submit"]').removeAttr('disabled');
					$callbackSuccess($data);
					if (($data.error != '') && ($data.error != null)) {
						console.error('ERROR via API: ', $data.error, 'from url', this.url);
					} else {
						$cached.JSONdata.set(((typeof(this.superCacheKey) != 'undefined') ? this.superCacheKey : this.url), $data);
					}
				},
				error:function($xr, $textstatus, $error) {
					jQuery('input[type="button"], input[type="submit"]').removeAttr('disabled');

					if ($textstatus != 'abort') {
						console.error('ERROR via API: "' + $textstatus + '": ' + $error + ' .... type was '+this.type+' .... url was '+this.url);
					}

					if ($textstatus == 'abort') {

						// we have deliberately aborted the AJAX request, therefore do not raise a warning, only log it
						console.log('Ajax request aborted: '+this.url);

					} else if ($xr.responseText && ($xr.responseText.indexOf('Authentication failed') > 0)) {

						// we can't RELY on $xr being set to anything in particular, but if $xr does contain an Authentication failed message then we definitely know we have to re-authenticate
						$models.login.setToken('');
						$controllers.login.display();
						$soupmail.notification.error('Login failed.  Please check you have entered your username and password correctly.');

					} else if ($xr.responseText && ($xr.responseText.indexOf('Token expired') > 0)) {

						// we can't RELY on $xr being set to anything in particular, but if $xr does contain a Timeout message then we definitely know we have to re-authenticate
						$models.login.setToken('');
						$controllers.login.display();
						$soupmail.notification.error('Session timeout, please log in again');

					} else if ($xr.status && ($xr.status == 500)) {

						// we can't RELY on $xr being set to anything in particular, but if $xr does contain a 500 error, then we know something strange has happened; deal with it in a generic way
						$soupmail.notification.error('An unusual error has occurred:  500 Internal Server Error.  Please try again, and if this error persists, please contact our support team, noting the specific action you performed and the screen you are viewing.');
						$soupmail.testFailure($xr.statusText);

					} else if (($callbackFailure != null) && (typeof($callbackFailure) == 'function')) {

						// parse error JSON data
						var $jsonErrorResponse = ($xr.responseText ? jQuery.parseJSON($xr.responseText) : '');
						if ($jsonErrorResponse && $jsonErrorResponse['errors']) {
							$jsonErrorResponse.error = '';
							jQuery.each($jsonErrorResponse['errors'], function($key, $messages) {
								jQuery.each($messages, function($k, $message) {
									$jsonErrorResponse.error += $soupmail.string.ucfirst($key).replace('_', ' ') + ' ' + $message + '<br />';
								});
							});
						}

						// a custom failure callback function was specified - lets run that
						$callbackFailure($jsonErrorResponse);
						$soupmail.testFailure($xr.responseText);

					} else {

						// fail any tests that were running
						$soupmail.testFailure('API ' + this.type + ' request error: ' + $textstatus + ' | ' + $error + ' | ' + $xr.responseText + ' @ ' + this.url);

						// if a custom failure error message string was specified, lets display that first, then the detailed error can appear afterwards
						var $customFailureString = '';
						if (($callbackFailure != null) && (typeof($callbackFailure) == 'string')) {
							$customFailureString = $callbackFailure;
						}

						// general error message - lets handle it now and let the user know something bad happened (even though it may be cryptic)
						var $jsonErrorResponse = ($xr.responseText ? jQuery.parseJSON($xr.responseText) : '');
						if ($jsonErrorResponse && $jsonErrorResponse['errors']) {
							$soupmail.modal.apiError($jsonErrorResponse.errors, $customFailureString);
						} else if ($jsonErrorResponse && $jsonErrorResponse['error']) {
							// change error to message for specific folder type error
							if ($customFailureString == 'Cannot delete folder type because it is currently in use.'){
								$soupmail.modal.message('Please reassign folder type for existing folders and try again.', $customFailureString);
							} else if ($customFailureString == 'Cannot delete folder status because it is currently in use.'){
								$soupmail.modal.message('Please reassign folder status for existing folders and try again.', $customFailureString);
							} else{
								$soupmail.modal.error($jsonErrorResponse.error, $customFailureString);
							}
						} else if ($error == 'Forbidden') {
							$soupmail.modal.error('Unable to process your request, permission denied.  You may not have permission to perform this action, or you may need to log in again', $customFailureString);
						} else if ($textstatus == 'error') {
							$soupmail.notification.error('A general error occurred: '+$error, $customFailureString);
						} else if ($textstatus == 'timeout') {
							$soupmail.modal.error('Unable to process your request, a timeout occurred.  Please check your internet connection is working correctly then try again.  If the problem persists, please check with your Soup Mail administrator to see if the server is experiencing any downtime.', $customFailureString);
						} else if ($textstatus == 'parsererror') {
							$soupmail.notification.error('Unable to process your request, a parser error occurred.  Please report this issue to your Soup Mail administrator.', $customFailureString);
						} else {
							$soupmail.notification.error('A general error occurred whilst attempting to process your request.  No additional information is available at this time.', $customFailureString);
						}

					}

				},
				dataType:'json'
			};

			if ($contentType) {
				$models.all.options['contentType'] = $contentType;
			}

			if ($actionType != 'token') {
				if ($models.login.getToken()) {
					$models.all.options['beforeSend'] = function(xhr) {
						// Add HTTP Basic Authentication using crypto-js library.
						var bytes = Crypto.charenc.Binary.stringToBytes($models.login.getToken());
						var base64 = Crypto.util.bytesToBase64(bytes);
						xhr.setRequestHeader('Authorization', 'Basic ' + base64);
					};
				}
			} else {
				$models.all.options['cache'] = false;
			}

			if ( ((typeof $params == 'string') && ($params != '')) || (jQuery.isArray($params) && ($params.length > 0)) || (jQuery.isPlainObject($params) && (jQuery.objectSize($params) > 0)) ) {
				$models.all.options['data'] = $params;
			}

			if ($superCache && $cached.JSONdata.exists($models.all.superCacheKey)) {
				jQuery('input[type="button"], input[type="submit"]').removeAttr('disabled');
				$callbackSuccess($cached.JSONdata.get($models.all.superCacheKey));
			} else {
				var $xhr = jQuery.ajax($models.all.options);
			}

			return $xhr;

		},

		getVersionInfo : function($callback, $errorHandler) {
			console.log('VERSIONINFO request');
			var url = $config.this_protocol + $config.this_host + $config.this_path + 'versioninfo.json';
			var options = {
				url:url,
				type:'GET',
				cache:false,
				data:{},
				success:$callback,
				error:function() {
					console.log('VERSIONINFO error! Check request completed, and check JSON is valid.');
				},
				dataType:'json'
			};
			var xhr = jQuery.ajax(options);
			return xhr;
		}

	}

};

$models.teamsettings = {
	/*
	load : function($callback) {
		$models.all.getDataFromAPI('teams/'+$models.login.getTeamid()+'.json', '', $callback, 'Unable to retrieve team settings.  You might not have permission to do so.');
	},

	save : function($formData, $callback) {
		$models.all.getDataFromAPI('teams/'+$models.login.getTeamid()+'.json', $formData, $callback, 'An error occurred whilst saving your general team settings', 'PUT');
	},

	saveTeamPerms : function($formData, $callback) {

		$models.all.getDataFromAPI('permissions.json', $formData, function($data) {
			$callback($data);
		}, 'An error occurred whilst saving your team permissions', 'PUT', 'generic', 'false', 'application/json');

	},
	*/
	inviteUser : function($formData, $callback, $failureHandler) {

		$models.all.getDataFromAPI('teams/'+$models.login.getTeamid()+'/users.json', $formData, function($data) {
			$callback($data);
		}, function($error) {
			if ($error.errors == 'Email address is already in use by an existing Soup Mail user.') {
				$soupmail.modal.error('The email address "' + $formData.email + '" is associated with an existing user in another team.  In this scenario, your available options are to add a different email address, or get the user to delete their existing account before inviting them.');
			} else {
				$soupmail.modal.error('The email address "' + $formData.email + '" cannot be added as a new user.  Please ensure the email address is correct.');
			}
			$failureHandler();
		}, 'POST');

	},

	// this function returns (inside a callback) a Boolean indicating True when the currently logged in user is an admin, and the *only* admin in the team, and when multiple users exist
	// if the current user is NOT an admin, the callback returns False
	// if the current team only contains one user (the current user), the callback returns False
	activeUserIsOnlyAdminInMultiUserTeam : function($callback) {

		$numberOfAdminsInTeam = 0;
		$models.users.getList({}, function($users) {

			jQuery.each($users.users, function($key, $user) {
				if ($user.admin) {
					$numberOfAdminsInTeam++;
				}
			});

			if (($numberOfAdminsInTeam <= 1) && $models.login.hasAdminPrivileges() && ($users.users.length > 1)) {
				$callback(true);
			} else {
				$callback(false);
			}

		});

	}

};

$models.main = {

	getFilterOptions : function() {

	},

	getEmailsList : function($params) {

		if ($params == undefined) {
			$params = {};
		}

		if ($params.person) {
			$params['filters[involving]'] = $params.person;
		}
		if ($params.tagid) {
			$params['filters[tags]'] = $params.tagid;
		}

		if (jQuery('#mod-search-searchword').val() && (jQuery('#mod-search-searchword').val() != 'Refine Search...')) {
			$params['filters[keywords]'] = jQuery('#mod-search-searchword').val();
		}

		var $filterByTags = [];
		var $filterByFolders = [];
		if ($params.folder_ids) {
			$filterByFolders = $params.folder_ids.split(',');
		}

		jQuery.each($soupmail.helpers.filter.$filters._items, function() {

			// filter My Emails
			if (this.selected && (this.id == 'search_emails_mine')) {
				$params['filters[involving]'] = $models.login.getUsername();
			}

			// filter Others Emails
			if (this.selected && (this.id == 'search_emails_other')) {
				$params['filters[not_involving]'] = $models.login.getUsername();
			}

			// filter any FROM checkboxes
			if (this.selected && (this.parent == 'search_emails_sender')) {
				$params['filters[from]'] = this.val; //this.id.replace('search_emails_sender', '');
			}

			// filter any TO checkboxes
			if (this.selected && (this.parent == 'search_emails_recepient')) {
				$params['filters[received_by]'] = this.val; //this.id.replace('search_emails_recepient', '');
			}

			// filter any INVOLVING checkboxes
			if (this.selected && (this.parent == 'search_emails_involving')) {
				if (typeof(this.val) == 'string') {
					$params['filters[involving]'] = this.val;
				} else {
					$params['filters[involving]'] = this.label; //this.id.replace('search_emails_recepient', '');
				}
			}

			// filter WITH ATTACHMENTS checkbox
			if (this.selected && (this.id == 'search_emails_attachments')) {
				 $params['filters[attachments]'] = true;
			}

			// filter any Folders
			if (this.selected && (this.parent == 'search_emails_folder')) {
				$filterByFolders.push(this.id.replace('search_folders_folder', ''));
			}

			// filter any Tags
			if (this.selected && (this.parent == 'search_categories_folder')) {
				$filterByTags.push(this.label);
			}

			// filter any Date Range
			var $dateFrom = new $soupmail.helpers.SoupMailDate();
			var $dateTo = new $soupmail.helpers.SoupMailDate();
			if (this.selected && (this.parent == 'search_emails_daterange')) {
				switch (this.val) {
					case 'today':
						$params['filters[date_from]'] = $dateFrom.morning().toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case 'week':
						$params['filters[date_from]'] = $dateFrom.morning().minusDays(7).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case 'month':
						$params['filters[date_from]'] = $dateFrom.morning().minusMonths(1).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case '3month':
						$params['filters[date_from]'] = $dateFrom.morning().minusMonths(3).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case '6month':
						$params['filters[date_from]'] = $dateFrom.morning().minusMonths(6).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case '12month':
						$params['filters[date_from]'] = $dateFrom.morning().minusMonths(12).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().toUTCString();
					break;
					case 'veryold':
						$params['filters[date_from]'] = $dateFrom.morning().minusMonths(400).toUTCString();
						$params['filters[date_to]'] = $dateTo.night().minusMonths(12).toUTCString();
					break;
				}
			}

			// filter any Date From
			if (this.selected && (this.id == 'search_emails_datefrom')) {
				var $dateFrom = new $soupmail.helpers.SoupMailDate(this.valAlternate + ' 00:00:00 ' + $dateFrom.toTimezoneOffset());
				$params['filters[date_from]'] = $dateFrom.morning().toUTCString();
			}

			// filter any Date To
			if (this.selected && (this.id == 'search_emails_dateto')) {
				var $dateTo = new $soupmail.helpers.SoupMailDate(this.valAlternate + ' 23:59:59 ' + $dateFrom.toTimezoneOffset());
				$params['filters[date_to]'] = $dateTo.night().toUTCString();
			}

		});

		if ($filterByFolders.length > 0) {
			$params['folder_ids'] = $filterByFolders.join(',');
			$params['filters[folder_ids]'] = $filterByFolders.join(',');
		}

		if ($filterByTags.length > 0) {
			$params['filters[tags]'] = $filterByTags.join(',');
		}

//		if (($params.folder_ids != null) && ($params.folder_ids != '')) {
//			$apiDataUrl = 'emails.json'; //folders/'+parseInt($params.folderid)+'/emails.json';
//			$apiCountUrl = 'folders/'+parseInt($params.folderid)+'/emails/count.json';
//$apiCountUrl = 'emails/count.json?folder_id='+parseInt($params.folderid);
//			} else {
			var $apiDataUrl = 'emails.json';
			var $apiCountUrl = 'emails/count.json';
//			}

		if (!$params.max_results) {
			$params['max_results'] = 100;
		}

		if ($models.main.currentEmailsListOffset > 0) {
			$params['offset'] = $models.main.currentEmailsListOffset;
		}

		// update the navigation with our latest params
		$controllers.all.setNavigation($params);

		// reduce $params to api-suitable data
		$apiRequestData = {};
		jQuery.each($params, function($key, $param) {
			if (($key == 'offset') || ($key == 'max_results') || ($key == 'team_id') || ($key == 'ids') || ($key.indexOf('filters') >= 0)) {
				$apiRequestData[$key] = $param;
			}
		});

		// get emails
		if ($models.main.currentGetListAjaxRequest) {
			$models.main.currentGetListAjaxRequest.abort();
		}
		$models.main.currentGetListAjaxRequest = $models.all.getDataFromAPI($apiDataUrl, $apiRequestData, function($data) {

			// turn the flag off as we want to be able to load more emails when we hit the bottom of the list again
			$controllers.main.currentlyRequestingMoreEmails = false;

			// handle emails with FROM headers in weird formats or when FROM header is NULL...
			jQuery.each($data.emails, function($key, $email) {
				$data.emails[$key] = $models.emails.handleInvalidEmailHeaders($email);
			});

			// add all found contacts & tags to cache
			jQuery.each($data.emails, function($key, $email) {

				$cached.contacts.add($email.from, 'from', true);
				$cached.contacts.add($email.to, 'to', true);
				$cached.contacts.add($email.cc, 'cc', true);

				if ($email.tags && ($email.tags != null) && ($email.tags.length > 0)) {
					jQuery.each($email.tags, function($key, $tag) {
						$tagObj = {id:$tag, name:$tag};
						$cached.tags.add($tagObj, true);
					});
				}

			});

			// render all emails in LHS list
			var $target = '.soupmail-main-left .email-list .widebox';
			if ($models.main.currentEmailsListOffset > 0) {

				$views.dashboard.renderEmails($data, $target, true);

			} else {

				$views.dashboard.renderEmails($data, $target, false);

				// remove any existing warning message
				jQuery('.warning-http-resources').remove();

				// if no emails in list, apply CSS class to indicate the list is empty
				if ($data.emails.length == 0) {
					jQuery('.email-list .widebox').html('<div class="no-results">No emails match your search.</div>');
					jQuery('.email-list').addClass('stripe-gradient');
				} else {
					jQuery('.email-list').removeClass('stripe-gradient');
				}

				// auto-load relevant email in preview pane
				var $emailId = 0;
				if (($params != undefined) && ($params.emailid > 0)) {
					$emailId = parseInt($params.emailid);
				} else if ($data.emails.length > 0) {
					$emailId = $data.emails[0].id;
					$views.main.renderEmail($emailId, $data.emails[0], $soupmail.string.basicHtmlEscape($data.emails[0].truncated_body, ''));
				}
				if ($emailId > 0) {
					$models.main.getEmailPreview($emailId);
				} else {
					$views.main.removeEmailPreview();
				}

				jQuery('.soupmail-main-left .email-list .widebox').fadeTo(50, 1.0);

				jQuery('.soupmail-main-left .email-list .email-list-item-'+$emailId).addClass('active');

			}

			$views.all.bindClickHandlersToItems();

		}, 'An error occurred whilst loading the list of emails for the specified filters/search', 'GET', 'generic', false);	// disable SuperCache due to #563... last bit was 'GET', 'generic', true);

		// get count of total number of emails
		jQuery('.count').addClass('loading');
		if ($models.main.currentGetSizeAjaxRequest) {
			$models.main.currentGetSizeAjaxRequest.abort();
		}
		$models.main.currentGetSizeAjaxRequest = $models.all.getDataFromAPI($apiCountUrl, $apiRequestData, function($data) {

			jQuery('.count').removeClass('loading');
			jQuery('.count span').text($data.total_result_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			$models.main.currentEmailsTotalCount = $data.total_result_count;

		}, 'An error occurred whilst calculating the total number of emails for the specified filters/search');

	},

	getEmailPreview : function(emailid) {

		// get message from API
		$models.emails.getItem(emailid, function($data) {

			// update hash in URL
			$controllers.all.setNavigation({folder_ids: $data.folder.id, email_id: emailid});

			// fetch the body html to use
			if (!$data.body) {
				$data.body = {plain : '--- This message contains no content ---', html : '<em>This message contains no content</em>'};
			}
			var $bodyhtml = ($data.body.html ? $data.body.html.replace('<style ', '<style scoped="scoped" ') : ($data.body.plain ? $soupmail.string.nl2br($data.body.plain) : '<em>This message contains no content</em>'));

			// IE8 and below do not support dynamic changing of <style> tags via DOM, which is used by makeEmailStylesScoped(), so if current browser is IE8 or below, *disable* all style tags
			if (jQuery.browser.msie && (parseInt(jQuery.browser.version, 10) <= 8)) {
				$bodyhtml = $bodyhtml.replace(/\<style/gi, '<noscript').replace(/\<\/style\>/gi, '</noscript>');
			}

			// now render the body html to the screen
			$views.main.renderEmail(emailid, $data, $bodyhtml);

			// apply scoping to css
			$soupmail.string.makeEmailStylesScoped();

			// apply related emails highlighting
			if ($data.references && $data.references.length) {
				$views.main.applyRelatedEmailsHighlighting($data.references);
			}
			if ($data.in_reply_to && $data.in_reply_to.length) {
				$views.main.applyRelatedEmailsHighlighting($data.in_reply_to);
			}

			if ($views.main.refineSearchHighlight == true){
				$views.main.applyKeywordsHighlighting();
			}

			// add any found tags, to the tag cache
			if ($data.tags && ($data.tags != null) && ($data.tags.length > 0)) {
				jQuery.each($data.tags, function($key, $tag) {
					$tagObj = {id:$tag, name:$tag};
					$cached.tags.add($tagObj, true);
				});
			}

		});

	}

};

$models.profilesettings = {

	validateFormData : function() {

		// remove any previous errors, if any
		jQuery('#system-message-container dl').remove();

		// quick validation
		if (
			!jQuery('#first_name').val() ||
			!jQuery('#last_name').val() ||
			!jQuery('#email').val()
		) {
			$soupmail.modal.error('Please ensure all fields are filled in');
			return false;
		}

		// if password and repeat password are both blank then don't validate
		if (jQuery('#password').val() != '' || jQuery('#password2').val() != ''){
			// quick validation
			if (jQuery('#password').val().length < 8){
				$soupmail.modal.error('Password must be at least 8 characters');
				return false;
			}
			if (/^(?=.*[a-z])(?=.*[A-Z])/.test(jQuery('#password').val()) == false){
				$soupmail.modal.error('Password must have mixed case');
				return false;
			}
			if (/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(jQuery('#password').val()) == false){
				$soupmail.modal.error('Password must be alphanumeric');
				return false;
			}
			if (jQuery('#password').val() != jQuery('#password2').val()) {
				$soupmail.modal.error('Your password and confirmation password do not match');
				return false;
			}
			if (jQuery('#remote_password').size() && (jQuery('#remote_password').val() != jQuery('#remote_password2').val())) {
				$soupmail.modal.error('Your email account password and confirmation password do not match');
				return false;
			}
		}

		return true;

	}

};

$models.mailboxsettings = {

	validateFormData : function() {

		// remove any previous errors, if any
		jQuery('#system-message-container dl').remove();

		// quick validation
		if (jQuery('#remote_password').size() && (jQuery('#remote_password').val() != jQuery('#remote_password2').val())) {
			$soupmail.notification.error('Your email account password and confirmation password do not match');
			return false;
		}

		return true;

	}

};

$models.accountcreate = {

	getTerms : function($callback) {

		$models.all.getDataFromAPI('terms.json', {}, function($data) {
			$callback($data);
		}, 'An error occurred whilst loading terms & conditions');

	},

	createTeam : function($formData, $callback) {
		$models.all.getDataFromAPI('teams.json', $formData, function($data) {
			$callback($data);
		}, 'An error occurred whilst creating a new team for your account', 'POST');
	}

};

$models.mobile_emails = {

	getEmailsList : function($params) {

		if ($params == undefined) {
			$params = {};
		}

		if (jQuery('#mod-search-searchword').val()) {
			$params['filters[keywords]'] = jQuery('#mod-search-searchword').val();
		}

		$filterByFolders = [];
		if ($params.folder_ids) {
			$filterByFolders = $params.folder_ids.split(',');
		}

		if ($filterByFolders.length > 0) {
			$params['folder_ids'] = $filterByFolders.join(',');
			$params['filters[folder_ids]'] = $filterByFolders.join(',');
		}

		var $apiDataUrl = 'emails.json';
		var $apiCountUrl = 'emails/count.json';

		if (!$params.max_results) {
			$params['max_results'] = 50;
		}

		if ($models.mobile_emails.currentEmailsListOffset > 0) {
			$params['offset'] = $models.mobile_emails.currentEmailsListOffset;
		}

		// get emails
		$models.all.getDataFromAPI($apiDataUrl, $params, function($data) {

			// turn the flag off as we want to be able to load more emails when we hit the bottom of the list again
			$controllers.mobile_emails.currentlyRequestingMoreEmails = false;

			// handle emails with FROM headers in weird formats or when FROM header is NULL...
			jQuery.each($data.emails, function($key, $email) {
				$data.emails[$key] = $models.emails.handleInvalidEmailHeaders($email);
			});

			// add all found contacts & tags to cache
			jQuery.each($data.emails, function($key, $email) {

				$cached.contacts.add($email.from, 'from', true);
				$cached.contacts.add($email.to, 'to', true);
				$cached.contacts.add($email.cc, 'cc', true);

			});

			var $target = '#mobile-emails .soupmail-main-list .widebox';

			if ($models.mobile_emails.currentEmailsListOffset > 0) {

				$views.mobile_emails.renderEmails($data, $target, true);

			} else {

				$views.mobile_emails.renderEmails($data, $target, false);
				jQuery('.soupmail-main-list').fadeTo(50, 1.0);

			}

		}, 'An error occurred whilst loading the list of emails for the specified filters/search', 'GET', 'generic', false);

		// get count of total number of emails
		$models.all.getDataFromAPI($apiCountUrl, $params, function($data) {

			jQuery('.email-count').text($data.total_result_count);

		}, 'An error occurred whilst calculating the total number of emails for the specified filters/search');

	}

};

$models.mobile_email_viewer = {

	getEmailPreview : function(emailid) {

		// update hash in URL
		$controllers.all.setNavigation({email_id: emailid});

		// get message from API
		$models.emails.getItem(emailid, function($data) {

			// render the message to the screen
			if (!$data.body) {
				$data.body = {plain : '--- This message contains no content ---', html : '<em>This message contains no content</em>'};
			}

			$views.mobile_email_viewer.renderEmail(emailid, $data, ($data.body.html ? $data.body.html.replace('<style ', '<style scoped="scoped" ') : ($data.body.plain ? $soupmail.string.nl2br($data.body.plain) : '<em>This message contains no content</em>')));

			// apply scoping to css
			$soupmail.string.makeEmailStylesScoped();

			// add any found tags, to the tag cache
			if ($data.tags && ($data.tags != null) && ($data.tags.length > 0)) {
				jQuery.each($data.tags, function($key, $tag) {
					$tagObj = {id:$tag, name:$tag};
					$cached.tags.add($tagObj, true);
				});
			}

		}, 'An error occurred whilst retrieving this email', '', '', true);

	}

};

$models.mobile_folders = {

	getFoldersList : function($params) {

		if ($params == undefined) {
			$params = {};
		}

		if (jQuery('#mod-search-searchword').val()) {
			$params['filters[keywords]'] = jQuery('#mod-search-searchword').val();
		}

		if (!$params.max_results) {
			$params['max_results'] = 50;
		}

		if ($models.mobile_folders.currentFoldersListOffset > 0) {
			$params['offset'] = $models.mobile_folders.currentFoldersListOffset;
		}

		if ($controllers.mobile_folders.fromBack) {
			$params['max_results'] = $controllers.mobile_folders.scrollMaxResults + 50;
			$models.mobile_folders.currentFoldersListOffset = $controllers.mobile_folders.scrollMaxResults;
			$controllers.mobile_folders.fromBack = false;
			jQuery('.folder-list').fadeTo(50, 1.0);
		}

		// get list of ALL folders we have access to
		$models.folders.getList($params, function($data) {

			// turn the flag off as we want to be able to load more emails when we hit the bottom of the list again
			$controllers.mobile_folders.currentlyRequestingMoreFolders = false;

			var $target = '#mobile-folders .folder-list';

			if ($models.mobile_folders.currentFoldersListOffset > 0) {

				$views.mobile_folders.renderFolders($data, $target, true);

			} else {

				$views.mobile_folders.renderFolders($data, $target, false);
				jQuery('.folder-list').fadeTo(50, 1.0);

			}

		});
	}

};



// WEBPACK FOOTER //
// ./src/js/models/base.models.js